import fileDownload from 'js-file-download'

export const downloadCSV = (csvString, filename) => {
  fileDownload(csvString, filename)
}
